/**
 * @file
 * A JavaScript file containing the tabbed functionality
 */

(function (Drupal, $) {
  Drupal.behaviors.teamContactDetails = {
    attach: function (context) {
      "use strict";

      $(once("team-contact-details-processed", ".team-contact-details", context))
        .each(function () {
          const filterButtons = document.querySelectorAll(
            ".team-contact-details .filter-button"
          );
          const contactItems = document.querySelectorAll(
            ".team-contact-details .team-contact-details__item"
          );

          if (!filterButtons.length > 0 || !contactItems.length > 0) {
            return;
          }

          filterButtons.forEach((button) => {
            button.addEventListener("click", (e) => {
              e.stopPropagation();
              e.preventDefault();
              const stateId = button.getAttribute("id");

              if (stateId) {
                filterButtons.forEach((btn) => btn.classList.remove("active"));

                button.classList.add("active");

                if (stateId === "state-all") {
                  contactItems.forEach(
                    (item) => (item.style.display = "block")
                  );
                } else {
                  contactItems.forEach((item) => (item.style.display = "none"));
                  const activeItems = document.querySelectorAll(`.${stateId}`);

                  if (activeItems.length > 0) {
                    activeItems.forEach(
                      (item) => (item.style.display = "block")
                    );
                  }
                }
              }

              const parentEl = button.closest(".team-contact-details");

              if (parentEl) {
                parentEl
                  .querySelector(".filter-options")
                  .classList.remove("active");
                parentEl
                  .querySelector(".current-selection")
                  .classList.remove("active");

                parentEl.querySelector(".current-selection").innerText =
                  button.innerText;
              }
            });
          });

          //handle mobile filter

          const currentSelectionElements = document.querySelectorAll(
            ".team-contact-details .filter-dropdown .current-selection"
          );

          if (!currentSelectionElements.length > 0) return;

          currentSelectionElements.forEach((element) => {
            const filterWrap = element.closest(".filter-dropdown");
            const filterOptions = element.nextElementSibling;

            element.addEventListener("click", (e) => {
              e.stopPropagation();
              element.classList.toggle("active");
              filterOptions.classList.toggle("active");
            });

            window.addEventListener("click", (e) => {
              if (!filterWrap.isEqualNode(e.target)) {
                element.classList.remove("active");
                filterOptions.classList.remove("active");
              }
            });
          });
        }); // once
    },
  };
})(Drupal, jQuery);
